"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var react_phone_number_input_1 = __importDefault(require("react-phone-number-input"));
var ComponentesDeEstilo = __importStar(require("./InputTelefone.styles"));
var StatusDoInput_1 = require("../Input/StatusDoInput");
var classnames_1 = __importDefault(require("classnames"));
var MensagemDeErro_1 = require("../Input/MensagemDeErro");
var IconeDeStatus_1 = require("../Input/IconeDeStatus");
var tema_1 = require("../../tema");
var pt_BR_json_1 = __importDefault(require("react-phone-number-input/locale/pt-BR.json"));
var en_json_1 = __importDefault(require("react-phone-number-input/locale/en.json"));
var InputTelefone = function (_a) {
  var onChange = _a.onChange,
    value = _a.value,
    rotulo = _a.rotulo,
    erro = _a.erro,
    sucesso = _a.sucesso,
    _b = _a.required,
    required = _b === void 0 ? false : _b,
    _c = _a.lingua,
    lingua = _c === void 0 ? "BR" : _c,
    desativado = _a.desativado,
    nome = _a.nome,
    containerProps = _a.containerProps,
    inputProps = __rest(_a, ["onChange", "value", "rotulo", "erro", "sucesso", "required", "lingua", "desativado", "nome", "containerProps"]);
  var referenciaDoInput = react_1.useRef(null);
  var focarNoInput = react_1.useCallback(function () {
    referenciaDoInput.current.focus();
  }, [referenciaDoInput]);
  var _d = react_1.useState(""),
    telefone = _d[0],
    setTelefone = _d[1];
  var estaComErro = !!erro;
  var deveExibirIcone = estaComErro || sucesso;
  var statusDoInput = estaComErro ? StatusDoInput_1.StatusDoInput.ERRO : sucesso ? StatusDoInput_1.StatusDoInput.SUCESSO : undefined;
  react_1.useEffect(function () {
    onChange({
      target: {
        value: telefone,
        name: nome
      }
    });
  }, [telefone, onChange, nome]);
  return react_1.default.createElement(tema_1.Tema, null, react_1.default.createElement(ComponentesDeEstilo.Container, __assign({
    className: classnames_1.default({
      "com-erro": estaComErro,
      desativado: desativado
    })
  }, containerProps), react_1.default.createElement(react_phone_number_input_1.default, __assign({
    disabled: desativado,
    name: nome,
    countrySelectProps: {
      tabIndex: -1
    },
    // @ts-ignore
    countryCallingCodeEditable: false,
    labels: lingua === "BR" ? pt_BR_json_1.default : en_json_1.default,
    ref: referenciaDoInput,
    defaultCountry: "BR",
    value: telefone,
    required: required,
    onChange: setTelefone,
    placeholder: rotulo
  }, inputProps)), deveExibirIcone && react_1.default.createElement(IconeDeStatus_1.IconeDeStatus, {
    status: statusDoInput,
    visivel: deveExibirIcone
  })), required && erro && react_1.default.createElement(MensagemDeErro_1.MensagemDeErro, {
    texto: erro,
    onClick: focarNoInput
  }));
};
exports.default = InputTelefone;